export default __webpack_public_path__ + "static/media/gpi-icon.078f76c6.webp";